import * as Yup from "yup";

export function inititalValues() {
  return { code: "" };
}

export function validationSchema(t) {
  return Yup.object({
    code: Yup.string()
      .matches(/^\d{6}$/, t("invalid_code"))
      .required(t("required_field")),
  });
}
